<template>
  <div v-if="hasTasksOrParams">
    <div v-for="shift_id in shifts" class="mb-5">

      <h3 v-if="needShowShiftHeader(shift_id)">
        <span>{{ getShiftName(shift_id) }}:</span>
      </h3>
      <div v-if="sortedAndFilteredTasks[shift_id] && sortedAndFilteredTasks[shift_id].length" class="group-header mb-2">Задачи:</div>
      <transition-group v-if="sortedAndFilteredTasks[shift_id] && sortedAndFilteredTasks[shift_id].length" class="list" name="list-complete" tag="div">
        <form @submit.prevent="task_save(v)" v-for="v in sortedAndFilteredTasks[shift_id]" :key="`task-${v.id}`" class="one d-block mb-3 list-complete-item" :class="{'one-done': v.is_done}">
          <div v-if="!task_isSelected(v)">
            <div class="form-check form-switch form-switch-lg">
              <input @click.stop="task_select(v);" v-model="v._is_done" type="checkbox" role="switch" :id="`flexSwitchCheckDefaultClose_${v.id}`" class="form-check-input">
              <label :for="`flexSwitchCheckDefaultClose_${v.id}`" class="form-check-label ms-3 mt-2" :class="{'one-deadline-label-offset': +v.deadline_time_only}"><span class="one-id">{{ v.id }}</span>{{ v.task }}</label>
              <div class="one-deadline" v-if="+v.deadline_time_only">
                <span :class="getDeadlineColor(v.deadline_time_only)">До: {{ v.deadline_inFormat }}</span>
              </div>
            </div>
            <div v-if="!v.is_done">
              <div v-if="!!v.description" class="one-desc text-secondary">
                {{ v.description }}
              </div>
            </div>
          </div>
          <div v-else>
            <div class="form-check form-switch form-switch-lg">
              <input v-model="v._is_done" type="checkbox" role="switch" :id="`flexSwitchCheckDefaultOpen_${v.id}`" class="form-check-input">
              <label :for="`flexSwitchCheckDefaultOpen_${v.id}`" class="form-check-label ms-3 mt-2" :class="{'one-deadline-label-offset': +v.deadline_time_only}"><span class="one-id">{{ v.id }}</span>{{ v.task }}</label>
              <div class="one-deadline" v-if="+v.deadline_time_only">
                <span :class="getDeadlineColor(v.deadline_time_only)">До: {{ v.deadline_inFormat }}</span>
              </div>
            </div>
            <div v-if="!!v.description" class="one-desc text-secondary">
              {{ v.description }}
            </div>
            <div class="mt-3">
              <textarea class="form-control mb-3" rows="4" v-model="v.user_comment" placeholder="Комментарий к задаче..."></textarea>
              <img :alt="v.task" :src="getImage(v.photo_1, `task-photo-${v.id}`)" :id="`task-photo-${v.id}`" :style="`display: ` + (v.photo_1 ? 'block' : 'none')" class="one-photo" />
              <short-time-line :model="v" />
              <div class="d-flex justify-content-between">
                <div>
                  <!-- To android/ios platform -->
                  <div class="offcanvas offcanvas-bottom" tabindex="-1" :id="`offcanvasPhoto` + v.id" aria-labelledby="offcanvasPhotoLabel">
                    <div class="offcanvas-header">
                      <h5 class="offcanvas-title" id="offcanvasPhotoLabel">Что хотите сделать?</h5>
                      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" :id="`task--btn-close-photo-selector-${v.id}`"></button>
                    </div>
                    <div class="offcanvas-body pt-0">
                      <button type="button" @click="task_takePhoto(v)" class="btn btn-primary w-100 mb-3 rounded-pill">Открыть камеру</button>
                      <button type="button" @click="task_selectPhoto(v)" class="btn btn-primary w-100 mb-3 rounded-pill">Выбрать из галереи</button>
                    </div>
                  </div>
                  <!-- /To android/ios platform -->
                  <!-- To web platform -->
                  <div class="d-none">
                    <input type="file" @change="task_attachFile($event, v, this)" :id="`task--append-file-${v.id}`" accept="capture=camera,image/*" />
                  </div>
                  <!-- /To web platform -->
                </div>
                <button v-if="['android', 'ios'].includes(PLATFORM)" type="button" class="btn flex-fill btn-secondary w-50 me-3" data-bs-toggle="offcanvas" :data-bs-target="`#offcanvasPhoto` + v.id" aria-controls="offcanvasPhoto">
                  <i class="bi bi-camera-fill me-2"></i>Фото
                </button>
                <button v-else type="button" @click="task_attachFileDialog(v)" class="btn flex-fill btn-secondary w-50 me-3">
                  <span v-if="task_hasAttachedFile(v)" class="text-success">Прикреплено</span>
                  <span v-else><i class="bi bi-camera-fill me-2"></i>Фото</span>
                </button>
                <button type="submit" class="btn flex-fill btn-primary w-50">Сохранить</button>
              </div>
            </div>
          </div>
        </form>
      </transition-group>
      <div v-if="sortedAndFilteredParams[shift_id] && sortedAndFilteredParams[shift_id].length" class="group-header mb-2">Параметры:</div>
      <transition-group v-if="sortedAndFilteredParams[shift_id] && sortedAndFilteredParams[shift_id].length" class="list" name="list-complete" tag="div">
        <form @submit.prevent="param_save(v)" v-for="v in sortedAndFilteredParams[shift_id]" :key="`param-${v.id}`" class="one d-block mb-3 list-complete-item" :class="{'one-done': v.is_done}">
          <div v-if="!param_isSelected(v)">
            <div class="form-check form-switch form-switch-lg">
              <input @click.stop="param_select(v)" v-model="v._is_done" type="checkbox" role="switch" :id="`flexSwitchCheckDefaultCloseParam_${v.id}`" class="form-check-input">
              <label :for="`flexSwitchCheckDefaultCloseParam_${v.id}`" class="form-check-label ms-3 mt-2"><span class="one-id">{{ v.id }}</span>{{ v.param.name }}</label>
            </div>
          </div>
          <div v-else>
            <div class="form-check form-switch form-switch-lg">
              <input v-model="v._is_done" type="checkbox" role="switch" :id="`flexSwitchCheckDefaultOpenParam_${v.id}`" class="form-check-input">
              <label :for="`flexSwitchCheckDefaultOpenParam_${v.id}`" class="form-check-label ms-3 mt-2"><span class="one-id">{{ v.id }}</span>{{ v.param.name }}</label>
            </div>
            <div class="mt-3">
              <!-- Param variants -->
              <div class="mb-3">
                <div v-if="+v.param.type === ParamModel.TYPE_STRING">
                  <textarea class="form-control" v-model="v.value" rows="4" />
                </div>
                <div v-else-if="+v.param.type === ParamModel.TYPE_IMAGE">
                  <img :alt="v.param.type" :src="getImage(v.value, `param-photo-${v.id}`)" :id="`param-photo-${v.id}`" :style="`display: ` + (v.value ? 'block' : 'none')" class="one-photo" />
                  <div>
                    <!-- To android/ios platform -->
                    <div class="offcanvas offcanvas-bottom" tabindex="-1" :id="`offcanvasParamPhoto` + v.id" aria-labelledby="offcanvasParamPhotoLabel">
                      <div class="offcanvas-header">
                        <h5 class="offcanvas-title" id="offcanvasParamPhotoLabel">Что хотите сделать?</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" :id="`param--btn-close-photo-selector-${v.id}`"></button>
                      </div>
                      <div class="offcanvas-body pt-0">
                        <button type="button" @click="param_takePhoto(v)" class="btn btn-primary w-100 mb-3 rounded-pill">Открыть камеру</button>
                        <button type="button" @click="param_selectPhoto(v)" class="btn btn-primary w-100 mb-3 rounded-pill">Выбрать из галереи</button>
                      </div>
                    </div>
                    <!-- /To android/ios platform -->
                    <!-- To web platform -->
                    <div class="d-none">
                      <input type="file" @change="param_attachFile($event, v, this)" :id="`param--append-file-${v.id}`" accept="capture=camera,image/*" />
                    </div>
                    <!-- /To web platform -->
                  </div>
                  <button v-if="['android', 'ios'].includes(PLATFORM)" type="button" class="btn btn-secondary w-100" data-bs-toggle="offcanvas" :data-bs-target="`#offcanvasParamPhoto${v.id}`" aria-controls="offcanvasParamPhoto">
                    <i class="bi bi-camera-fill me-2"></i>Фото
                  </button>
                  <button v-else type="button" @click="param_attachFileDialog(v)" class="btn flex-fill btn-secondary w-100 me-3">
                    <span v-if="param_hasAttachedFile(v)" class="text-success">Прикреплено</span>
                    <span v-else><i class="bi bi-camera-fill me-2"></i>Фото</span>
                  </button>
                </div>
                <div v-else-if="+v.param.type === ParamModel.TYPE_NUMBER">
                  <input v-model="v.value" type="number" class="form-control">
                </div>
                <div v-else-if="+v.param.type === ParamModel.TYPE_DATETIME">
                  <input v-model="v.value" type="date" class="form-control">
                </div>
                <div v-else-if="+v.param.type === ParamModel.TYPE_TIME">
                  <div class="d-flex justify-content-between">
                    <div class="flex-fill w-50 me-3 text-center">
                      <label class="form-label mb-0">Часы:</label>
                      <select :value="parseInt(v.value_hours)" @change="e => v.value_hours = e.target.value" class="form-control text-center">
                        <option :value="h-1" v-for="h in 24">
                          {{ HH(h-1) }}
                        </option>
                      </select>
                    </div>
                    <div class="flex-fill w-50 text-center">
                      <label class="form-label mb-0">Минуты:</label>
                      <select :value="parseInt(v.value_mins)" @change="e => v.value_mins = e.target.value" class="form-control text-center">
                        <option :value="m-1" v-for="m in 60">
                          {{ MM(m-1) }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Param variants -->
              <short-time-line :model="v" />
              <div class="d-flex justify-content-between">
                <div class="w-50 me-3">&nbsp;</div>
                <button type="submit" class="btn flex-fill btn-primary w-50">Сохранить</button>
              </div>
            </div>
          </div>
        </form>
      </transition-group>

    </div>
  </div>
  <div v-else>
    <info-block label="Видимо вы всё сделали.<br>Отличная работа!" icon="bi-emoji-sunglasses-fill" css-classes="text-secondary" class="pt-5 pb-5" />
  </div>
</template>

<script>
import EnvConfig from "@/env";
import getImage from "@/mixins/getImage";
import nodeList from "@/mixins/nodeList";
import ShortTimeLine from "@/components/ShortTimeLine";
import { TaskModel } from "@/models/TaskModel";
import { ParamModel } from "@/models/ParamModel";
import { selectPhoto, takePhoto } from "@/helpers/camera";

export default {
  components: {
    ShortTimeLine
  },
  mixins: [
    getImage,
    nodeList,
  ],
  data() {
    return {
      PLATFORM: EnvConfig.PLATFORM,
      ParamModel,
      selectedTasks: [],
      selectedParams: [],
      SUPER_SRC: null,
    }
  },
  computed: {
    tasks: {
      cache: false,
      get: () => new TaskModel().getList(),
    },
    sortedAndFilteredTasks: {
      cache: false,
      get() {
        return this._sortedAndFilteredList(this.tasks);
      }
    },
    params: {
      cache: false,
      get: () => new ParamModel().getList(),
    },
    sortedAndFilteredParams: {
      cache: false,
      get() {
        return this._sortedAndFilteredList(this.params);
      }
    },
    shifts() {
      const array = Object.assign([], Object.keys(this.sortedAndFilteredTasks), Object.keys(this.sortedAndFilteredParams));
      return [...new Set(array)];
    },
    hasTasksOrParams() {
      return Object.keys(this.sortedAndFilteredTasks).length || Object.keys(this.sortedAndFilteredParams).length;
    },
  },
  methods: {
    needShowShiftHeader(shift_id) {
      return this.sortedAndFilteredTasks[shift_id] && this.sortedAndFilteredTasks[shift_id].length
          || this.sortedAndFilteredParams[shift_id] && this.sortedAndFilteredParams[shift_id].length;
    },
    task_takePhoto(model) {
      takePhoto(image => {
        const img = document.getElementById(`task-photo-${model.id}`);
        img.src = model.photo_1 = `${image}`;
        img.style.display = 'block';
      });
      this.task_closeSelectPhotoPopup(model);
    },
    task_selectPhoto(model) {
      selectPhoto(image => {
        const img = document.getElementById(`task-photo-${model.id}`);
        img.src = model.photo_1 = `${image}`;
        img.style.display = 'block';
      });
      this.task_closeSelectPhotoPopup(model);
    },
    task_closeSelectPhotoPopup(model) {
      document.getElementById(`task--btn-close-photo-selector-` + model.id).click();
    },
    task_attachFileDialog(model) {
      const inputFile = document.getElementById(`task--append-file-${model.id}`);
      inputFile.click();
    },
    task_hasAttachedFile(model) {
      const inputFile = document.getElementById(`task--append-file-${model.id}`);
      return inputFile?.files?.length;
    },
    async task_attachFile(event, model) {
      const getBase64 = file => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      };
      const file = event.target.files.length ? event.target.files[0] : null;
      if (!file) {
        return;
      }

      try {
        model.photo_1 = await getBase64(file);
      } catch (e) {
        console.error('Error uploading file', e);
      }
    },
    task_select(m) {
      m._is_done = !m._is_done;
      this.selectedTasks.push(+m.id);
    },
    task_isSelected(m) {
      return true;
      return this.selectedTasks.includes(+m.id);
    },
    task_save(m) {
      this.selectedTasks = this.selectedTasks.filter(id => id !== +m.id);
      m.is_done = m._is_done;
      m.flush();
    },
    param_takePhoto(model) {
      takePhoto(image => {
        const img = document.getElementById(`param-photo-${model.id}`);
        img.src = model.value = `${image}`;
        img.style.display = 'block';
      });
      this.param_closeSelectPhotoPopup(model);
    },
    param_selectPhoto(model) {
      selectPhoto(image => {
        const img = document.getElementById(`param-photo-${model.id}`);
        img.src = model.value = `${image}`;
        img.style.display = 'block';
      });
      this.param_closeSelectPhotoPopup(model);
    },
    param_closeSelectPhotoPopup(model) {
      document.getElementById(`param--btn-close-photo-selector-` + model.id).click();
    },
    param_attachFileDialog(model) {
      const inputFile = document.getElementById(`param--append-file-${model.id}`);
      inputFile.click();
    },
    param_hasAttachedFile(model) {
      const inputFile = document.getElementById(`param--append-file-${model.id}`);
      return inputFile?.files?.length;
    },
    async param_attachFile(event, model) {
      const getBase64 = file => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      };

      const file = event.target.files.length ? event.target.files[0] : null;
      if (!file) {
        return;
      }

      try {
        model.value = await getBase64(file);
      } catch (e) {
        console.error('error uploading file', e);
      }
    },
    param_select(m) {
      m._is_done = !m._is_done;
      this.selectedParams.push(+m.id);
    },
    param_isSelected(m) {
      return true;
      return this.selectedParams.includes(+m.id);
    },
    param_save(m) {
      this.selectedParams = this.selectedParams.filter(id => id !== +m.id);
      m.is_done = m._is_done;
      m.flush();
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/styles/scss/list.scss";

.group-header {
  font-size: 15px;
  background: #222;
  color: #FFF !important;
  display: inline-block;
  padding: 0 13px;
  border-radius: 15px;
}
</style>